import { initializeApp } from "firebase/app";
import { collection, getDocs, getFirestore, query, where } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { debugLog } from "../Utils/debugLog";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const collectionRef = collection(db, "scene_metadata");
const q = query(collectionRef, where("isTemporary", "==", true));

getDocs(q)
    .then((querySnapshot) => {
        debugLog("Query results:", querySnapshot.docs.length);
    })
    .catch((error: unknown) => {
        console.error("Error querying documents:", error);
    });

export { db, storage };
